<template>
	<v-flex>
		<v-date-picker ref="startDate" class="mr-3" :value="range.startDate" :no-title="true" @input="startDateChanged"></v-date-picker>
		<v-date-picker ref="endDate" :value="range.endDate" :no-title="true" :min="endDateOptions.min" :disabled="endDateOptions.disabled" @input="endDateChanged"></v-date-picker>
	</v-flex>
</template>

<script>
	export default {
		props: {
			value: {
				type: Object,
				default: () => {
					return {
						startDate: (new Date()).toLocaleDateString('fr-CA'),
						endDate: null
					}
				}
			},
			period: {
				type: String,
				default: 'month'
			}
		},
		data () {
			return {
				range: {
					startDate: null,
					endDate: null
				},
				endDateOptions: {
					min: null,
					disabled: true
				},
			}
		},
		methods: {
			defaultEndDate (ymdDate)
			{
				var parts = ymdDate.split('-')
				var endDate = new Date(parts[0], parts[1] - 1, parts[2])

				switch (this.period.toLowerCase()) {
					case 'week':
					 	endDate.setDate(endDate.getDate() + 7)
						break;

					default: {
					 	endDate.setMonth(endDate.getMonth() + 1)
					 	break;
					}
				}				 	
			 	return endDate.toISOString().substr(0, 10)
			},
			startDateChanged (value)
			{
				this.range.startDate = value

				if (this.range.startDate) {
					this.endDateOptions.min = this.range.startDate
					this.endDateOptions.disabled = false

					if ((!this.range.endDate) || (this.range.startDate > this.range.endDate)) {
						this.range.endDate = this.defaultEndDate(this.range.startDate)
					}
				}

				this.$emit('input', this.range)
			},
			endDateChanged (value) 
			{
				this.range.endDate = value
				this.$emit('input', this.range)
			},
			initComponent ()
			{
				if (typeof this.value) {
					this.range = this.value

					if (this.range.startDate && this.range.endDate) {
						this.endDateOptions.min = this.range.startDate
						this.endDateOptions.disabled = false
					}
				}
			}
		},
		mounted () {
			this.$nextTick(this.initComponent)
		},
		watch: {
			value (props) 
			{
				console.log(props)
				this.initComponent()
			}
		}
	}
</script>